import {useSelector} from 'react-redux';

//components
import PackageFeatureCard from '@stencil/gi-components/src/PackageFeatureCard/PackageFeatureCard';

//omniture
import useOmnitureLoaded from '@stencil/omniture-analytics/src/hooks/useOmnitureLoaded';
import {detailsClick} from '@stencil/omniture-analytics/src/constants/details';

//selectors
import {packagesSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

const PackageFeatureCardContainer = ({handlePackageClick}) => {
  const packagesData = useSelector(packagesSelector);

  const inclusionsList = packagesData?.[0]?.ratePlans?.[0]?.inclusionsList || [];

  const inclusionsListToShow = inclusionsList?.filter(item => item?.packageBenefit) || [];

  const onPackageLoad = () => {
    useOmnitureLoaded(detailsClick.elitePackage.elitePackageLoaded);
  };

  if (!inclusionsListToShow.length) return null;

  return (
    <PackageFeatureCard
      inclusionsListToShow={inclusionsListToShow}
      handleClick={handlePackageClick}
      onPackageLoad={onPackageLoad}
      isDweb={true}
    />
  );
};

export default PackageFeatureCardContainer;
